import { Box} from '@mui/material'
import React from 'react'
import { avatarURL } from '../utils/constants';
import './Avatar.css';

const Avatar = () => {
  return (
    <Box sx={{justifyContent:'space-around', display:'flex', height:{sm:'60vh',md:'90vh'}, alignItems:'center', objectFit:'contain'}} >
        <Box >
           <img src={avatarURL} className={'avatar'} alt="Avatar"/>
            </Box>
    </Box>
  )
}

export default Avatar